import type { AutoMatchDecisionRow } from './types';

const NAME_MATCH_LABEL: Record<
  NonNullable<AutoMatchDecisionRow['nameMatch']>,
  string
> = {
  exact: 'Exact',
  non_exact: 'Non-exact',
};

const ACTION_LABEL: Record<
  NonNullable<AutoMatchDecisionRow['reconciliationOutcome']>,
  string
> = {
  dedup_only: 'Dedupe',
  alias_only: 'Alias',
};

// "Non-exact · Dedupe": how the staged name compared to the matched entity's,
// and what the confirm did with it. Null when neither half is known.
export const matchResolutionLabel = ({
  nameMatch,
  reconciliationOutcome,
}: Pick<AutoMatchDecisionRow, 'nameMatch' | 'reconciliationOutcome'>):
  string | null => {
  // ACTION_LABEL and NAME_MATCH_LABEL are complete Records over their unions, so
  // adding a member to either union is a compile error here. The values arrive as
  // unchecked JSON: a value outside the union is dropped rather than labelled, but
  // the decision log only ever writes dedup_only / alias_only for an auto-match row.
  const parts = [
    nameMatch && NAME_MATCH_LABEL[nameMatch],
    reconciliationOutcome && ACTION_LABEL[reconciliationOutcome],
  ].filter(Boolean);
  return parts.length ? parts.join(' · ') : null;
};
